import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AkamaiService {
  private readonly SCRIPT_URL = 'https://p11.techlab-cdn.com/6a28a9ec591043e8dee834b0.js';
  private activeCount = 0;
  private scriptElement: HTMLScriptElement | null = null;

  injectScript(): void {
    this.activeCount++;
    if (this.activeCount === 1) {
      const script = document.createElement('script');
      script.src = this.SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
      this.scriptElement = script;
    }
  }

  removeScript(): void {
    this.activeCount = Math.max(0, this.activeCount - 1);
    if (this.activeCount === 0 && this.scriptElement) {
      this.scriptElement.remove();
      this.scriptElement = null;
    }
  }
}
